export const euro = (v, digits = 0) =>
  "€" + Number(v || 0).toLocaleString("en-IE", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });

export const dollar = (v, digits = 0) =>
  "$" + Number(v || 0).toLocaleString("en-US", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });

export function money(amount, currency = "EUR") {
  const symbols = { EUR: "€", USD: "$", GBP: "£" };
  const symbol = symbols[currency] || "";
  return (
    symbol +
    Number(amount || 0).toLocaleString("en-IE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  );
}
